import { Component, OnInit } from '@angular/core';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public correo:string;
  public contra:string;
  constructor(private servicio:ServicioFirebaseService) { }

  ngOnInit() {
  }

  iniciarSesion(){
    this.servicio.entrarSesionCorreo(this.correo,this.contra);
  }

}
